<div class="main row">
  @if (isNewVehicle && newExperience) {
    <section class="agent-confirm">
      <div>
        <img src="assets/images/lock_doodle.svg" alt="SentToAgent" />
      </div>
      <h2 data-cy="confirmationScreenHeader" class="heading-text">Your Agent has been notified</h2>
      <p class="agent-msg">They'll reach out to finish adding your vehicle.</p>
      <!-- <section class="agent-bio">
      <div
        class="agent-img"
          style="
            background-image: url(agents[0].photoUrl?agents[0].photoUrl:'') 50% / cover no-repeat;
          "
      ></div>
      <div class="agent-details">
        <p class="agent-name">{{ agents[0].fullName }}</p>
        <p class="agent-designation">Agent</p>
      </div>
    </section> -->
      @for (agent of agents; track agent) {
        <div class="agent-item-column">
          <agent-item
            [defaultContactNumber]="defaultContactNumber"
            [agent]="agent"
            [newTemplate]="true"
          ></agent-item>
        </div>
      }
      <section class="agent-action">
        <div class="row done-button">
          <button
            ds-button
            class="font-weight-semibold capitalize"
            (click)="done()"
            aria-label="Done"
            data-cy="primaryButton"
          >
            Done
          </button>
        </div>
      </section>
    </section>
  }
  @if (isNewVehicle && !newExperience) {
    <ds-confirmation
      [confirmationData]="confirmationData$ | async"
      [policyNumber]="policyNumber"
      [vehicleName]="vehicleName"
    >
      <ds-confirmation-link-area>
        @if (!classicOnlyAutoPolicyOrCompOnlyAdv) {
          <hr aria-hidden="true" class="fill" />
        }
        <div class="row done-button">
          <button
            ds-button
            class="font-weight-semibold capitalize"
            (click)="done()"
            aria-label="Done"
            data-cy="primaryButton"
          >
            Done
          </button>
        </div>
      </ds-confirmation-link-area>
    </ds-confirmation>
  }
  <!-- <ng-container *ngIf="!isNewVehicle">
<ds-confirmation
  [confirmationData]="replaceVehicleConfirmationData$ | async"
  [policyNumber]="policyNumber"
  [vehicleName]="vehicleName"
  >
  <ds-confirmation-link-area>
    <hr *ngIf="!classicOnlyAutoPolicyOrCompOnlyAdv" aria-hidden="true" class="fill" />
    <div class="row done-button">
      <button
        ds-button
        class="font-weight-semibold capitalize"
        (click)="done()"
        aria-label="Done"
        data-cy="primaryButton"
        >
        Done
      </button>
    </div>
  </ds-confirmation-link-area>
</ds-confirmation>
</ng-container> -->
</div>
